import { preloadImage } from '@mail/3promo';
import docsDarkImage from 'img/unlimited-docs/modal/dark/docs.png';
import presentationDarkImage from 'img/unlimited-docs/modal/dark/presentation.png';
import spreadsheetDarkImage from 'img/unlimited-docs/modal/dark/spreadsheet.png';
import docsLightImage from 'img/unlimited-docs/modal/light/docs.png';
import presentationLightImage from 'img/unlimited-docs/modal/light/presentation.png';
import spreadsheetLightImage from 'img/unlimited-docs/modal/light/spreadsheet.png';
import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { UnlimitedDocumentsTariffType } from 'reactApp/modules/unlimitedDocuments/unlimitedDocuments.const';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

import type { UnlimitedDocumentsModalProps } from './UnlimitedDocumentsModal';

const IMAGE_PRELOAD_TIMEOUT = 3 * 1000;

export const renderUnlimitedDocumentsModal = (data: UnlimitedDocumentsModalProps) => {
    openPopupHelper({
        popupName: popupNames.UNLIMITED_DOCUMENTS_MODAL,
        data,
        onClose: data.onClose,
    });
};

export const closeUnlimitedDocumentsModal = () => closePopupHelper(popupNames.UNLIMITED_DOCUMENTS_MODAL);

export const unlimitedDocumentsCoverImagesConfig: {
    dark: { [k in UnlimitedDocumentsTariffType]: any };
    light: { [k in UnlimitedDocumentsTariffType]: any };
} = {
    dark: {
        [UnlimitedDocumentsTariffType.document]: docsDarkImage,
        [UnlimitedDocumentsTariffType.spreadsheet]: spreadsheetDarkImage,
        [UnlimitedDocumentsTariffType.presentation]: presentationDarkImage,
    },
    light: {
        [UnlimitedDocumentsTariffType.document]: docsLightImage,
        [UnlimitedDocumentsTariffType.spreadsheet]: spreadsheetLightImage,
        [UnlimitedDocumentsTariffType.presentation]: presentationLightImage,
    },
};

export const getUnlimitedDocumentsModalCoverImageUrl = (isDarkTheme: boolean, type: UnlimitedDocumentsTariffType) => {
    if (isDarkTheme) {
        return unlimitedDocumentsCoverImagesConfig.dark[type] || docsDarkImage;
    }

    return unlimitedDocumentsCoverImagesConfig.light[type] || docsLightImage;
};

export const preloadUnlimitedDocumentsModalCover = async (type: UnlimitedDocumentsTariffType) => {
    const coverImageUrl = getUnlimitedDocumentsModalCoverImageUrl(isDarkThemeModeEnabled(), type);
    await preloadImage({ src: coverImageUrl, timeout: IMAGE_PRELOAD_TIMEOUT });
};
